import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { GenericMenuComponent } from "../generic-menu-component.model";
import { MenuItem } from "../menu-item.model";
import { MenuService } from "../menu.service";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent extends GenericMenuComponent implements OnChanges, OnDestroy {
  @Input() items: MenuItem[] = [];
  @Input() isMemberMenu = false;
  @Input() menuTitle = "";

  currentItems: MenuItem[] = [];

  constructor(private menuService: MenuService) { super(); }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items) {
      this.currentItems = changes.items.currentValue;

      if (changes.items.isFirstChange()) { return; }

      if (changes.items.currentValue !== changes.items.previousValue) {
        this.refresh = true;
      }
    }
  }

  ngOnDestroy(): void {}

  get currentMenuItems() {
    return this.toPrimeMenuItems(this.currentItems);
  }

  trackByIndex(index: number): number {
    return index;
  }

  closeSubMenu(): void {
    this.menuService.toggleMenuState(false);
  }

  navigateExternal(path: string): void {
    window.location.href = path;
  }
}
